var $5cd130489822fa21$exports = {};
$5cd130489822fa21$exports = {
  "removeButtonLabel": "\uC81C\uAC70",
  "removeDescription": "\uD0DC\uADF8\uB97C \uC81C\uAC70\uD558\uB824\uBA74 Delete \uD0A4\uB97C \uB204\uB974\uC2ED\uC2DC\uC624."
};
export { $5cd130489822fa21$exports as default };